const state = {
  view: null, // Create the MapView
  projectLayers: []
}

const getters = {
  view: (state) => state.view,
  projectLayers: (state) => state.projectLayers
}

const mutations = {
  changeView: (state, view) => {
    state.view = null
    if (view) state.view = view
  },
  changeProjectLayers: (state, projectLayers = []) => {
    state.projectLayers = projectLayers
  }
}

const actions = {
  changeView ({ commit }, view) {
    commit('changeView', view)
  },
  changeProjectLayers ({ commit }, projectLayers) {
    commit('changeProjectLayers', projectLayers)
  }
}

export default { state, getters, mutations, actions }
